import * as React from "react"
import { connect } from "react-redux"
import { bindActionCreators, Dispatch } from "redux"
import LocalAuthorityListComponent from  "./budgets-annexes"
import { LocalAuthority, Instruction } from "../../../model"
import * as actionCreators from "../../../action-creators"
import { Profile } from "../../../domain/sfp/user-domain"
import { ReducerState, MappedActionsProps } from "../../../reducer"
import { RouteComponentProps } from "react-router"
import { findInstructions } from "../../../service/sfp/instructions-service-2"
import { NotificationLevel } from "../../notification"

class budgetsAnnexes extends React.Component<InjectedProps, State> {
	protected editingProfiles: Profile[] = [
		Profile.SuperAdmin,
		Profile.RegionAdmin,
		Profile.LocalAuthorityAdmin
	]
	protected viewProfiles: Profile[] = [
		Profile.LocalAuthorityConsultant
	]
	private abortController: AbortController = new AbortController

	constructor(props: InjectedProps) {
			super(props)
			this.state = {
				addLocalAuthority: false,
				addChildLocalAuthority: false,
				instructions: [],
				instructionsLoaded: false,
				loadingInstructions: false,
				loadingLocalAuthorities: [],
				localAuthorities: [],
				localAuthority: null,
				resourcesLoaded: false,
				viewLocalAuthority: false,
				editExtraLocalAuthority: false,
				selectedSlug: "",
				currentPath:""
			}
		}

		componentDidMount() {
			this.setState({currentPath:window.location.pathname})
			this.initState(this.props)
			this.currentLA(this.props)
			
		}

		componentDidUpdate() {
			this.initState(this.props)
			if(this.state.currentPath !== window.location.pathname ){
				this.setState({currentPath:window.location.pathname})
				this.currentLA(this.props)
			}
		}

		componentWillUnmount() {
			this.abortController.abort()
		}

		render() {
			const loading =  this.props.loadingLocalAuthoritiesChildren

			return  <LocalAuthorityListComponent
			selectedSlug={this.state.selectedSlug}
			addLocalAuthority={this.state.addLocalAuthority}
			addChildLocalAuthority={this.state.addChildLocalAuthority}
			currentUser={this.props.currentUser}
			editingLocalAuthorities={this.state.loadingLocalAuthorities}
			viewingLocalAuthoritiesChildren={this.props.loadingLocalAuthoritiesChildren}
			editingProfiles={this.editingProfiles}
			loading={loading}
			currentLocalAuthority={this.props.currentLocalAuthority}
			loadingInstructions={this.state.loadingInstructions}
			instructions={this.state.instructions}
			localAuthorities={this.props.localAuthoritiesChildren}
			localAuthoritiesChildren={this.props.localAuthoritiesChildren}
			localAuthority={this.state.localAuthority}
			viewLocalAuthority={this.state.viewLocalAuthority}
			editExtraLocalAuthority={this.state.editExtraLocalAuthority}
			viewProfiles={this.viewProfiles}
			onClickViewLocalAuthorityChild={(l) => this.handleClickViewChildLocalAuthority(l)}
			onClickAddLocalAuthority={() => this.handleClickAddLocalAuthority()}
			onClickAddChildLocalAuthority={(l) => this.handleClickAddChildLocalAuthority(l)}
			onClickViewLocalAuthority={l => this.handleClickViewLocalAuthority(l)}
			onCloseEditLocalAuthority={() => this.handleCloseViewLocalAuthority()}	
			onLocalAuthorityUpdated={() => this.handleLocalAuthorityUpdated()}
			onLocalAuthorityUpdatedPA={(l)=>this.handleOnSameLocalAthority(l)}
		/>


		}

		private handleClickAddLocalAuthority(): void {
			this.setState({ addLocalAuthority: true })
		}

		private handleClickViewLocalAuthority(localAuthority: LocalAuthority): void {
			this.setState({ viewLocalAuthority: true, localAuthority })
		}

		// For updating PA if LA is same
		private handleOnSameLocalAthority(l) {
			this.props.actions.fetchCurrentLocalAuthorityIfCollectivitiesPage(l.id)
		}

		private handleCloseViewLocalAuthority(): void {
			this.setState({ viewLocalAuthority: false, localAuthority: null })
		}

		private handleLocalAuthorityUpdated() {
			this.currentLA(this.props)
			this.props.actions.fetchLocalAuthorities()
			this.setState({ viewLocalAuthority: false })
		}
	
		// Add child into local authority
		private handleClickAddChildLocalAuthority(localAuthority: LocalAuthority): void {
			this.setState({ addChildLocalAuthority: true, localAuthority })
		}

		private handleClickViewChildLocalAuthority(localAuthority: LocalAuthority): void {
			this.props.actions.fetchCurrentLocalAuthorityIfNeeded(localAuthority.slug)
			this.props.history.push({pathname:`/${localAuthority.slug}`,state:{ la:localAuthority }})
		}


		private initState(props: InjectedProps): void {
			if (this.state.loadingInstructions) return
			if (this.state.instructionsLoaded) return

			this.setState({ loadingInstructions: true }, () => {
				findInstructions(this.abortController.signal)
				.then(instructions => {
					this.setState({
						instructions,
						instructionsLoaded: true,
						loadingInstructions: false
					})
				})
				.catch(reason => {
					this.setState({
						instructionsLoaded: true,
						loadingInstructions: false
					}, () => {
						this.props.actions.notify(
							NotificationLevel.Danger,
							"Impossible de charger les instructions",
							reason
						)
					})
				})
			})
		}
		private currentLA(props: InjectedProps) {
			let sulg= window.location.pathname
			let sulg1= sulg.replace(/budgetsannexes/g,'')
			let finalSlug= sulg1.replace(/\//g,'')
			this.props.actions.fetchLocalAuthoritiesChildren(finalSlug)
		}
}




export default connect(mapStateToProps, mapDispatchToProps)(budgetsAnnexes)

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
	return state
}

interface Params {}

interface State {
	addLocalAuthority: boolean
	addChildLocalAuthority: boolean
	instructions: Instruction[]
	instructionsLoaded: boolean
	loadingInstructions: boolean
	loadingLocalAuthorities: LocalAuthority[]
	localAuthorities: LocalAuthority[]
	localAuthority: LocalAuthority
	resourcesLoaded: boolean
	viewLocalAuthority: boolean
	editExtraLocalAuthority:boolean
	selectedSlug: string
	currentPath:string
}

type InjectedProps = ReducerState & MappedActionsProps & RouteComponentProps<Params>


// WEBPACK FOOTER //
// ./src/component/page/budgetsAnnexe/index.tsx